import load from 'sdk/payeeAudit';
import { takeEvery } from 'redux-saga/effects';
import { LOAD } from 'model/payeeAudit';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeEvery(
    LOAD.ACTION,
    callAction({
      api: load,
      dataName: ORM,
      type: LOAD,
    })
  );
}
